import { formatDate, formatDateTime } from "../../../i18n/format";
import { useInterfaceLocale } from "./useInterfaceLocale";

/** An instant as a date ("5 Sep 2026" / "05.09.2026") or with the clock time, inside a `<time>`. */
export function DateTime({
  value,
  style = "date",
  timeZone,
}: {
  value: string | Date | null | undefined;
  style?: "date" | "dateTime";
  /** Fixed zone for a deterministic render (the catalogue and its baselines); the browser's zone otherwise. */
  timeZone?: string;
}) {
  const locale = useInterfaceLocale();
  const format = style === "date" ? formatDate : formatDateTime;
  const text = format(value, locale, timeZone ? { timeZone } : {});
  const iso = value instanceof Date ? value.toISOString() : (value ?? undefined);
  return (
    <time data-component="DateTime" dateTime={iso} className="tabular-nums">
      {text}
    </time>
  );
}
